import { render } from "./SettingView.vue?vue&type=template&id=0c2c56ae&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"

import "./SettingView.vue?vue&type=style&index=0&id=0c2c56ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2c56ae"]])

export default __exports__